import React, { createContext, useCallback, useState } from 'react';
import ActivationInProgressModal from './activation-in-progress-modal';
import ActivationInProgressBackground, {
	type ProgressBarStatus,
} from './activation-in-progress-background';

export enum ModalState {
	OPEN = 'open',
	CLOSED = 'closed',
}

interface ActivationInProgressContextInterface {
	modalState: ModalState;
	onOpen: () => void;
	onDismiss: () => void;
}
export const ActivationInProgressContext = createContext<ActivationInProgressContextInterface>({
	modalState: ModalState.CLOSED,
	onOpen: () => void 0,
	onDismiss: () => void 0,
});

type ActivationInProgressPageProps = {
	onOpen: () => void;
	onDismiss: () => void;
	status: ProgressBarStatus;
};
const ActivationInProgressPage = ({ onDismiss, onOpen, status }: ActivationInProgressPageProps) => {
	const [modalState, setModalState] = useState(ModalState.OPEN);

	const changeModalState = (state: ModalState) => {
		setModalState(state);
	};

	const handleDismiss = useCallback(() => {
		changeModalState(ModalState.CLOSED);
		onDismiss();
	}, [onDismiss]);

	const handleOpen = useCallback(() => {
		changeModalState(ModalState.OPEN);
		onOpen();
	}, [onOpen]);

	return (
		<ActivationInProgressContext.Provider
			value={{
				modalState,
				onOpen: handleOpen,
				onDismiss: handleDismiss,
			}}
		>
			<ActivationInProgressBackground status={status} />
			<ActivationInProgressModal />
		</ActivationInProgressContext.Provider>
	);
};
export default ActivationInProgressPage;
